import type { ConfirmOutcome } from '@appercut/round-vue';

const CONFIRM_TIMEOUT_MS = 60000;

export function settleConfirm(confirming: Promise<ConfirmOutcome>): Promise<ConfirmOutcome | { kind: 'unanswered' }> {
  return new Promise((resolve) => {
    const unanswered = (): void => resolve({ kind: 'unanswered' });
    const timer = setTimeout(unanswered, CONFIRM_TIMEOUT_MS);
    const settle = (outcome: ConfirmOutcome): void => {
      clearTimeout(timer);
      resolve(outcome);
    };

    confirming.then(settle, () => {
      clearTimeout(timer);
      unanswered();
    });
  });
}
